export default __webpack_public_path__ + "static/media/Quantum_Dashboard.818b544b.svg";